import { useAuth } from "../auth"

export default function useUserCanWriteAndDelete() {
  const { user } = useAuth()
  if (!user) return false
  if (user.ruolo === "amministratore" || user.ruolo === "operatore" || user.is_superuser) return true
  return false
}

export function useUserIsAdmin() {
  const { user } = useAuth()
  if (!user) return false
  return user.ruolo === "amministratore" || user.is_superuser
}
